import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const Logo = () => (
    <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" width="40" height="40">
      <defs>
        <linearGradient id="mixGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor:'#06b6d4', stopOpacity:1}} />
          <stop offset="50%" style={{stopColor:'#8b5cf6', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#ec4899', stopOpacity:1}} />
        </linearGradient>
      </defs>
      <rect x="10" y="10" width="25" height="25" fill="url(#mixGrad)" opacity="0.7" rx="5"/>
      <rect x="45" y="10" width="25" height="25" fill="url(#mixGrad)" opacity="0.5" rx="5" transform="rotate(10 57.5 22.5)"/>
      <rect x="10" y="45" width="25" height="25" fill="url(#mixGrad)" opacity="0.5" rx="5" transform="rotate(-10 22.5 57.5)"/>
      <rect x="45" y="45" width="25" height="25" fill="url(#mixGrad)" opacity="0.7" rx="5"/>
      <circle cx="40" cy="40" r="16" fill="white"/>
      <path d="M 32 40 L 37 45 L 49 33" stroke="url(#mixGrad)" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <motion.header
      className={`header ${scrolled ? 'header-scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo-link">
            <div className="logo">
              <Logo />
              <span className="logo-text">Mixality</span>
            </div>
          </Link>

          <div className={`nav-menu ${mobileMenuOpen ? 'nav-menu-open' : ''}`}>
            <a href="#services" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Services</a>
            <Link to="/about" className="nav-link" onClick={() => setMobileMenuOpen(false)}>About</Link>
            <Link to="/contact" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
            <Link to="/audit" className="nav-link nav-link--highlight" onClick={() => setMobileMenuOpen(false)}>Free Assessment</Link>
          </div>

          <div className="nav-actions">
            <a
              href="mailto:mrichard.hudson@mixality.com?subject=Free Discovery Call"
              className="btn btn-primary nav-btn"
            >
              Book a Call
            </a>
            <button
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`hamburger ${mobileMenuOpen ? 'hamburger-open' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
